"use client";

import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { homeCardVariants } from "../foundations/home-variants";

export interface HomeExpandableCardV2Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  open?: boolean;
  onToggle?: () => void;
  children: React.ReactNode;
}

export function HomeExpandableCardV2({
  title,
  subtitle,
  open = false,
  onToggle,
  children
}: HomeExpandableCardV2Props) {
  return (
    <div className={cn(homeCardVariants({ variant: "interactive" }), "overflow-hidden")}>
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between px-4 py-3 text-left"
      >
        <div>
          <h4 className="text-sm font-semibold text-slate-900 dark:text-zinc-100">{title}</h4>
          {subtitle && <p className="text-xs text-slate-500 dark:text-zinc-400">{subtitle}</p>}
        </div>
        <ChevronDown className={cn("h-4 w-4 transition-transform", open && "rotate-180")} />
      </button>
      {open && <div className="border-t border-slate-200/70 p-4 dark:border-zinc-800">{children}</div>}
    </div>
  );
}
